import { helper } from '@ember/component/helper';

/**
 * Confronta due valori per uguaglianza, ritorna false se uno dei due è vuoto
 */
var isEqualNotEmpty = helper(function isEqualNotEmpty([first, second]) {
  // Check per valori vuoti
  if (first === undefined || first === '' || second === undefined || second === '') {
    return false;
  }

  // Gestione speciale per false booleano
  if (first === false || second === false) {
    return first === false && second === false;
  }
  return first === second;
});

export { isEqualNotEmpty as default };
//# sourceMappingURL=is-equal-not-empty.js.map
